<div class="property-building-details">
  @if (spinner) {
    <app-spinner></app-spinner>
  }

  @switch (currentView) {
    @case ("main") {
      <form [formGroup]="form">
        <div class="main-card">
          <div class="row">
            <!-- Service Selection -->
            <div class="col-md-6">
              <select-paginated
                [placeholder]="'يرجى اختيار الخدمة'"
                [label]="'الخدمة'"
                [required]="true"
                [items]="servicesList"
                [selectedContract]="selectedService"
                [pageCount]="servicesPageCount"
                [bindLabel]="'name'"
                (params)="getDynamicServices($event)"
                (itemData)="setServiceData($event)"
              >
              </select-paginated>
            </div>
            <!-- Client Selection -->
            <div class="col-md-6">
              <a class="add-item" (click)="addClient()">
                <img alt="" src="/assets/images/svg/add-icon-blue.svg" /> إضافة
                عميل
              </a>
              <select-paginated
                [placeholder]="'يرجى تحديد العميل'"
                [label]="'اسم العميل'"
                [required]="true"
                [items]="clientsList"
                [selectedContract]="selectedClient"
                [pageCount]="clientsPageCount"
                [bindLabel]="'full_name'"
                (params)="getDynamicClients($event)"
                (itemData)="setClientData($event)"
              >
              </select-paginated>
            </div>
          </div>

          <!-- Step 2: Customer's Units (always visible) -->
          <div class="units-selection" [class.slide-down]="showUnitsDropdown">
            <div class="section-header">
              <img
                src="/assets/images/svg/building.svg"
                alt="building"
                class="section-icon"
              />
              <h3 class="section-title">الوحدات الخاصة بالعميل</h3>
            </div>

            @if (!showUnitsDropdown) {
              <div class="placeholder-state">
                <p>اختر الخدمة والعميل لعرض الوحدات</p>
              </div>
            } @else if (showUnitsDropdown && customerUnits.length === 0) {
              <div class="empty-units-state">
                <h4 class="empty-title">ما عندك وحدات مسجّلة</h4>
                <p class="empty-subtitle">
                  أضف وحدتك العقاريّة أوّلاً - ثمّ تحدّد مستوى الباقة.
                </p>
                <button
                  type="button"
                  class="add-unit-btn"
                  (click)="addNewUnit()"
                >
                  <img src="/assets/images/svg/add-no-bg-icon.svg" alt="add" />
                  <span>إضافة وحدة أخرى</span>
                </button>
              </div>
            } @else if (showUnitsDropdown && customerUnits.length > 0) {
              <div class="cards-container">
                <button
                  type="button"
                  class="add-unit-card"
                  (click)="addNewUnit()"
                >
                  <img src="/assets/images/svg/add-no-bg-icon.svg" alt="add" />
                  <span>إضافة وحدة أخرى</span>
                </button>

                @for (unit of customerUnits; track unit.id) {
                  <div
                    class="selection-card"
                    [class.selected]="
                      form.get('property_unit_id')?.value === unit.id
                    "
                    (click)="selectUnit(unit)"
                  >
                    <div class="card-content">
                      <div class="card-info">
                        <h4 class="card-title">
                          {{ unit.unit_name || unit.reference_number }}
                        </h4>
                        <div class="card-details">
                          @if (unit.address_area || unit.address_city) {
                            <span class="detail-item">
                              <img
                                src="/assets/images/svg/location-icon.svg"
                                alt="location"
                              />
                              {{ unit.address_area?.name }} ,
                              {{ unit.address_city?.name }}
                            </span>
                          }
                          @if (unit.surfaces_space) {
                            <span class="detail-item">
                              <img
                                src="/assets/images/svg/area-icon.svg"
                                alt="area"
                              />
                              {{ unit.surfaces_space }} م²
                            </span>
                          }
                        </div>
                      </div>
                      <div class="radio-button">
                        <input
                          type="radio"
                          [id]="'unit-' + unit.id"
                          name="property_unit"
                          [value]="unit.id"
                          [checked]="
                            form.get('property_unit_id')?.value === unit.id
                          "
                        />
                        <label [for]="'unit-' + unit.id"></label>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          <div
            class="packages-selection"
            [class.slide-down]="showPackagesDropdown"
          >
            <div class="section-header">
              <img
                src="/assets/images/svg/layers.svg"
                alt="packages"
                class="section-icon"
              />
              <h3 class="section-title">مستوى الباقة المتاحة لهذه الوحدة</h3>
            </div>

            @if (!showPackagesDropdown) {
              <div class="placeholder-state">
                <p>مستوى الباقة المتاحة لهذه الوحدة</p>
              </div>
            } @else {
              <div class="cards-container">
                @for (package of availablePackages; track package.id) {
                  <div
                    class="selection-card"
                    [class.selected]="
                      form.get('package_id')?.value === package.id
                    "
                    (click)="selectPackage(package)"
                  >
                    <div class="card-content">
                      <div class="radio-button">
                        <input
                          type="radio"
                          [id]="'package-' + package.id"
                          name="package"
                          [value]="package.id"
                          [checked]="
                            form.get('package_id')?.value === package.id
                          "
                        />
                        <label [for]="'package-' + package.id"></label>
                      </div>

                      <div class="card-info">
                        <h4 class="card-title">{{ package.name }}</h4>
                        <div class="package-price">
                          <span class="price-label">يبدأ من</span>
                          <div class="price-value">
                            <span class="amount">{{
                              package.price || package.starting_price | number
                            }}</span>
                            <img
                              src="assets/images/svg/Riyal.svg"
                              alt="ريال"
                              class="currency-icon"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                @if (availablePackages.length === 0) {
                  <div class="empty-state">
                    <p>لا توجد باقات متاحة لهذه الوحدة</p>
                  </div>
                }
              </div>
            }
          </div>

          <!-- Submit Button -->
          <div class="row">
            <div class="col-12">
              @if (alertmsg) {
                <div class="alert-box">
                  <img
                    src="assets/images/svg/error-icon.svg"
                    class="close-alert"
                    (click)="hideErrorMSG()"
                    alt="close"
                  />
                  <p class="alert-msg">{{ errorMessage }}</p>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="confirm-next-step">
          <button class="btn btn-green" (click)="save()">التالي</button>
        </div>
      </form>
    }

    @case ("add-unit") {
      <add-property-unit
        [embeddedMode]="true"
        [prefilledCustomerId]="form.get('customer_id')?.value?.toString()"
        [prefilledServiceId]="form.get('service_id')?.value"
        (unitAdded)="onUnitAdded($event)"
        (cancelled)="onAddUnitCancelled()"
      ></add-property-unit>
    }
  }
</div>
